module.exports = __webpack_public_path__ + "static/media/easteregg.d.ts.1c246ca8.map";